const getDefaultState = () => {
  return {
    models: {
      XPERIO: 'protect',
      'TRANSITIONS-XTRACTIVE': 'protect',
      'TRANSITIONS-SIGNATURE': 'protect',
      EPS: 'protect',
      'VARILUX-PHYSIO': 'correct',
      'VARILUX-X-SERIES': 'correct',
      'EYEZEN-BOOST': 'correct',
      'EYEZEN-START': 'correct',
      'VARILUX-S-SERIES': 'correct',
      'VARILUX-E-SERIES': 'correct',
      'CRIZAL-SAPPHIRE-PLUS-UV': 'optimize',
      'CRIZAL-FORTE-PREVENCIA': 'optimize',
    },
    transportsList: [
      {
        title: 'Voiture',
        isActive: false,
      },
      {
        title: 'Transports',
        isActive: false,
      },
      {
        title: 'Vélo',
        isActive: false,
      },
      {
        title: 'À Pied',
        isActive: false,
      },
    ],
    steps: [
      {
        cards: [
          {
            message: 'Pour une gêne en vision de loin',
          },
          {
            message: 'Pour une gêne en vision de près',
          },
          {
            message: 'Pour une gêne en vision de près et de loin',
          },
          {
            message: 'Renouvellement de mon équipement / visite de contrôle',
          },
        ],
        checked: null,
        title: 'Pour quelle(s) raison(s) avez-vous rendu visite à votre ophtalmologiste ?',
        other: 'Autre raison',
        type: 'correct',
        inputType: 'OCQBig',
        titleSummary: 'Vous avez rendu visite à votre ophtalmologiste :',
      },
      {
        correctionsByAges: [
          {
            message: 'Entre 0 et 17 ans',
          },
          {
            message: 'Entre 18 et 29 ans',
          },
          {
            message: 'Entre 30 et 39 ans',
          },
          {
            message: 'Entre 40 et 45 ans',
          },
          {
            message: '45 ans et plus',
          },
        ],
        title: 'Quel âge avez-vous ?',
        type: 'correct',
        inputType: 'OCQNoImages',
        checked: null,
        titleSummary: 'Vous avez :',
      },
      {
        cards: [
          {
            message: 'Difficulté à voir net le tableau de bord (GPS, rétroviseurs, ...)',
            priority: 4,
            name: ['VARILUX-X-SERIES', 'VARILUX-S-SERIES', 'EYEZEN-BOOST', 'EYEZEN-START'],
            checked: false,
          },
          {
            message: 'Réflexion sur route mouillée par temps ensoleillé',
            priority: 3,
            name: ['XPERIO'],
            checked: false,
          },
          {
            message: 'Éblouissement des phares de voitures et éclairages de nuit',
            priority: 4,
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            checked: false,
          },
          {
            message: 'Éblouissement par soleil rasant',
            priority: 1,
            name: ['TRANSITIONS-XTRACTIVE'],
            checked: false,
          },
        ],
        title: 'Avez-vous déjà rencontré la ou les gêne(s) visuelle(s) suivante(s) en voiture ?',
        other: 'Aucune gêne',
        type: 'protect',
        checked: false,
        inputType: 'OCQBig',
        indexImg: 3,
        titleSummary: 'En voiture :',
        isDeactivated: true,
      },
      {
        cards: [
          {
            message: 'Efforts pour lire sur vos écrans pendant vos trajets',
            priority: 4,
            name: ['EYEZEN-BOOST', 'EYEZEN-START', 'VARILUX-X-SERIES'],
            checked: false,
          },
          {
            message: 'Sensation de vertige ou de tangage dans les escaliers (ou dans une foule en mouvement)',
            priority: 4,
            name: ['VARILUX-X-SERIES', 'VARILUX-S-SERIES', 'VARILUX-E-SERIES'],
            checked: false,
          },
          {
            message: 'Difficulté à bien lire les panneaux, particulièrement de nuit',
            priority: 4,
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            checked: false,
          },
          {
            message: 'Sensibilité aux changements lumineux',
            priority: 2,
            name: ['TRANSITIONS-SIGNATURE'],
            checked: false,
          },
        ],
        title: 'Avez-vous déjà rencontré la ou les gêne(s) visuelle(s) suivante(s) dans les transports ?',
        other: 'Aucune gêne',
        type: 'protect',
        checked: false,
        inputType: 'OCQBig',
        indexImg: 4,
        titleSummary: 'En transports :',
        isDeactivated: true,
      },
      {
        cards: [
          {
            message: 'Difficulté à bien distinguer tout votre environnement net en roulant',
            priority: 4,
            name: ['VARILUX-PHYSIO', 'VARILUX-X-SERIES', 'VARILUX-S-SERIES'],
            checked: false,
          },
          {
            message: 'Réflexion sur route mouillée par temps ensoleillé',
            priority: 3,
            name: ['XPERIO'],
            checked: false,
          },
          {
            message: 'Éblouissement des phares de voitures et éclairages de nuit',
            priority: 4,
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            checked: false,
          },
          {
            message: 'Sensibilité aux changements lumineux (ex. : passage sous un pont)',
            priority: 2,
            name: ['TRANSITIONS-SIGNATURE'],
            checked: false,
          },
        ],
        title: 'Avez-vous déjà rencontré la ou les gêne(s) visuelle(s) suivante(s) en vélo ?',
        other: 'Aucune gêne',
        type: 'protect',
        checked: false,
        inputType: 'OCQBig',
        indexImg: 5,
        titleSummary: 'En vélo :',
        isDeactivated: true,
      },
      {
        cards: [
          {
            message: 'Difficultés à lire une carte, vos sms, …',
            priority: 4,
            name: ['VARILUX-X-SERIES', 'EYEZEN-BOOST', 'EYEZEN-START'],
            checked: false,
          },
          {
            message: 'Sensation de vertige ou de tangage dans une foule en mouvement (ou dans les escaliers)',
            priority: 4,
            name: ['VARILUX-X-SERIES', 'VARILUX-S-SERIES', 'VARILUX-E-SERIES'],
            checked: false,
          },
          {
            message: 'Réflexion sur route mouillée par temps ensoleillé',
            priority: 3,
            name: ['XPERIO'],
            checked: false,
          },
          {
            message: 'Éblouissement des phares de voitures et éclairages de nuit',
            priority: 4,
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            checked: false,
          },
          {
            message: "Sensibilité aux changements lumineux (ex. : passage de l'intérieur à l'extérieur)",
            priority: 2,
            name: ['TRANSITIONS-SIGNATURE'],
            checked: false,
          },
        ],
        title: 'Avez-vous déjà rencontré la ou les gêne(s) visuelle(s) suivante(s) à pied ?',
        other: 'Aucune gêne',
        type: 'protect',
        checked: false,
        inputType: 'OCQBig',
        indexImg: 6,
        titleSummary: 'A pied :',
        isDeactivated: true,
      },
      {
        title: 'Dans une journée, où passez-vous le plus de temps ?',
        type: 'protect',
        inputType: 'slider',
        value: 50,
        indexImg: 7,
        titleSummary: 'Dans une journée, vous passez votre temps :',
      },
      /*      {
        cards: [
          {
            priority: 2,
            message: 'Sensibilité aux changements lumineux',
            name: ['TRANSITIONS-SIGNATURE'],
            checked: false,
          },
          {
            priority: 4,
            message: 'Changements réguliers de distances de regard dans votre quotidien',
            name: ['VARILUX-X-SERIES'],
            checked: false,
          },
          {
            priority: 4,
            message: 'Difficultés en action «minutieuse» de près',
            name: ['VARILUX-X-SERIES'],
            checked: false,
          },
          {
            priority: 3,
            message: 'Éblouissement en journée par temps ensoleillé',
            name: ['XPERIO'],
            checked: false,
          },
          {
            priority: 4,
            message: 'Salissures ou rayures régulières sur vos verres',
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            checked: false,
          },
        ],
        title: 'Vous êtes-vous déjà retrouvé dans une ou plusieurs de ces situations ?',
        type: 'protect',
        inputType: 'OCQBig',
                titleSummary: 'Vous vous êtes déjà retrouvé dans les situations suivantes :',
      },*/
      {
        correctionsByAges: [
          {
            message: "Moins d'1 heure",
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            priority: 3,
          },
          {
            message: 'Entre 1 et 3 heures',
            name: ['EPS', 'CRIZAL-SAPPHIRE-PLUS-UV'],
            priority: 1,
          },
          {
            message: 'Entre 3 et 6 heures',
            name: ['EPS', 'CRIZAL-FORTE-PREVENCIA'],
            priority: 1,
          },
          {
            message: '6 heures et plus',
            name: ['EPS', 'CRIZAL-FORTE-PREVENCIA'],
            priority: 1,
          },
        ],
        title: 'Combien de temps par jour passez-vous devant un écran ?',
        type: 'optimize',
        inputType: 'OCQNoImages',
        checked: null,
        titleSummary: 'Temps passé devant un écran :',
        indexImg: 8,
      },
      /*      {
        cards: [
          {
            priority: 4,
            message: 'Difficulté à trouver la bonne position devant votre écran',
            name: ['VARILUX-X-SERIES', 'EYEZEN-BOOST', 'EYEZEN-START'],
            checked: false,
          },
          {
            priority: 4,
            message: 'Reflets en éclairage direct (ex: vitre dans le dos tout en étant face à un écran)',
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            checked: false,
          },
          {
            priority: 2,
            message: 'Fatigue visuelle en fin de journée',
            name: ['CRIZAL-FORTE-PREVENCIA'],
            checked: false,
          },
          {
            priority: 4,
            message: 'Perte de contraste et de netteté sur votre écran',
            name: ['CRIZAL-SAPPHIRE-PLUS-UV'],
            checked: false,
          },
        ],
        title: 'Ressentez-vous des gênes face aux écrans ?',
        other: 'Aucune gêne',
        type: 'optimize',
        checked: false,
                titleSummary: 'Vous rencontrez ces gênes :',
        inputType: 'OCQBig',
      },
      {
        cards: [
          {
            message: 'Sport en intérieur',
            checked: false,
          },
          {
            message: 'Sport en extérieur',
            checked: false,
          },
          {
            message: 'Activité nautique',
            checked: false,
          },
          {
            message: 'Jeux vidéos, Télévision',
            checked: false,
          },
          {
            message: 'Activité manuelle',
            checked: false,
          },
          {
            message: 'Activité culturelle',
            checked: false,
          },
        ],
        title: 'Quelles sont les activités principales que vous pratiquez ?',
        type: 'optimize',
        inputType: 'OCQSmall',
        checked: false,
                        titleSummary: 'Vous pratiquez :',
        other: 'Aucune de ces activités',
      },*/
      {},
    ],
    isFilled: false,
  };
};

export default {
  state: {
    models: {},
    steps: [],
    transportsList: [],
    dataStep: [],
    correctResults: [],
    result: {
      correct: {
        name: String,
        priority: Number,
      },
      protect: {
        name: String,
        priority: Number,
      },
      optimize: {
        name: String,
        priority: Number,
      },
    },
    isFilled: false,
  },
  actions: {
    changeSlideValue: ({ commit, getters }, data) => {
      commit('SET_SLIDE_VALUE', { data, getters });
    },
    setChecked: ({ commit, getters }, data) => {
      commit('SET_CHECKED', { data, getters });
    },
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    setCheckedOther: ({ dispatch, commit, getters }, data) => {
      dispatch('Uncheck', { step: data, index: -1 });
      commit('SET_CHECKED_OTHER', { data, getters });
    },
    Uncheck: ({ commit, getters }, data) => {
      commit('UNCHECK', { data, getters });
    },
    setMonoCheck: ({ commit, getters }, data) => {
      commit('SET_MONO_CHECK', { data, getters });
    },
    QuizzFilled: ({ commit }, data) => {
      commit('QUIZZ_FILLED', data);
    },
    deactivatesTransports({ commit }) {
      commit('DEACTIVATES');
    },
  },
  mutations: {
    QUIZZ_FILLED(state, payload) {
      state.isFilled = payload;
    },
    SET_SLIDE_VALUE(state, { data, getters }) {
      getters.getSteps[data.step].value = data.value;
    },
    SET_MONO_CHECK(state, { data, getters }) {
      if (getters.getSteps[data.step].checked === data.index) {
        getters.getSteps[data.step].checked = null;
        return;
      }
      getters.getSteps[data.step].checked = data.index;
    },
    SET_CHECKED(state, { data, getters }) {
      if (getters.getSteps[data.step].checked) {
        getters.getSteps[data.step].checked = false;
      }
      getters.getSteps[data.step].cards[data.index].checked = !getters.getSteps[data.step].cards[data.index].checked;
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    SET_CHECKED_OTHER(state, { data, getters }) {
      if (getters.getSteps[data].type === 'correct') {
        getters.getSteps[data].checked = getters.getSteps[data].checked === -1 ? null : -1;
      } else {
        getters.getSteps[data].checked = !getters.getSteps[data].checked;
      }
    },
    UNCHECK(state, { data, getters }) {
      getters.getSteps[data.step].cards.forEach((card, index) => {
        if (index !== data.index) {
          card.checked = null;
        }
      });
    },
    DEACTIVATES(state) {
      for (let i = 0; i < state.transportsList.length; i++) {
        if (state.transportsList[i].isActive === false) {
          state.steps[i + 2].isDeactivated = true;
        } else {
          state.steps[i + 2].isDeactivated = false;
        }
      }
    },
  },
  getters: {
    getResults: (state, getters) => {
      let ret = {
        correct: [],
        protect: [],
        optimize: [],
      };
      getters.getSteps.forEach(step => {
        if (step.inputType)
          switch (step.inputType) {
            case 'OCQBig':
              if (step.type !== 'correct' && !step.isDeactivated) {
                let tab = [];
                step.cards.forEach(card => {
                  if (card.checked) {
                    tab.push(card.message);
                  }
                });
                if (tab.length > 0) {
                  if (step.indexImg === 7) {
                    ret['optimize'].push({ title: step.titleSummary, answers: tab });
                  } else {
                    ret[step.type].push({ title: step.titleSummary, answers: tab });
                  }
                }
                if (step.checked) {
                  ret[step.type].push({ title: step.titleSummary, answers: step.other });
                }
              } else if (!step.isDeactivated) {
                if (step.checked === -1) {
                  ret[step.type].push({ title: step.titleSummary, answers: step.other });
                } else {
                  ret[step.type].push({ title: step.titleSummary, answers: step.cards[step.checked].message });
                }
              }
              break;
            case 'OCQList':
              step.cards.forEach(card => {
                if (card.checked) {
                  ret['optimize'].push({ title: step.titleSummary, answers: card.message });
                }
              });
              break;
            case 'OCQNoImages':
              ret[step.type].push({
                title: step.titleSummary,
                answers: step.correctionsByAges[step.checked].message,
              });
              break;
            case 'OCQSmall':
              step.cards.forEach(card => {
                if (card.checked) {
                  ret[step.type].push({ title: step.titleSummary, answers: card.message });
                }
              });
              break;
            case 'slider':
              ret['optimize'].push({
                title: step.titleSummary,
                answers:
                  step.value < 50
                    ? "Majorité du temps à l'intérieur"
                    : step.value > 50
                    ? "Majorité du temps à l'extérieur"
                    : "Autant à l'extérieur qu'à l'intérieur",
              });
              break;
          }
      });
      return ret;
    },
    getModelsFromQuizz: (state, getters) => {
      let model = {
        correct: { name: null, priority: null },
        protect: { name: null, priority: null },
        optimize: { name: null, priority: null },
      };
      let tab = [
        ['EYEZEN-START', 'EYEZEN-START', 'EYEZEN-START', 'EYEZEN-START', 'VARILUX-X-SERIES'],
        ['EYEZEN-START', 'EYEZEN-BOOST', 'EYEZEN-BOOST', 'EYEZEN-BOOST', 'VARILUX-X-SERIES'],
        ['EYEZEN-START', 'EYEZEN-BOOST', 'EYEZEN-BOOST', 'VARILUX-X-SERIES', 'VARILUX-X-SERIES'],
      ];
      if (
        !(
          getters.getSteps[0].checked === null ||
          getters.getSteps[0].checked === -1 ||
          getters.getSteps[0].checked === 3
        )
      )
        model.correct.name = tab[getters.getSteps[0].checked][getters.getSteps[1].checked];
      getters.getSteps.forEach(step => {
        if (step.type !== 'correct') {
          switch (step.inputType) {
            case 'slider':
              if (Number(step.value) >= 50 && (!model.protect.priority || model.protect.priority > 2)) {
                model.protect = { name: 'TRANSITIONS-SIGNATURE', priority: 2 };
              } else if (!model.protect.priority || model.protect.priority > 4) {
                model.protect = { name: 'EPS', priority: 4 };
              }
              break;
            case 'OCQNoImages':
              if (step.checked !== null) {
                step.correctionsByAges[step.checked].name.forEach(name => {
                  if (
                    !model[state.models[name]].priority ||
                    step.correctionsByAges[step.checked].priority < model[state.models[name]].priority
                  )
                    model[state.models[name]] = {
                      name: name,
                      priority: step.correctionsByAges[step.checked].priority,
                    };
                });
              }
              break;
            default:
              if (step.cards) {
                step.cards.forEach(card => {
                  if (card.checked && card.name) {
                    card.name.forEach(name => {
                      if (
                        card.priority &&
                        (!model[state.models[name]].priority || card.priority < model[state.models[name]].priority)
                      ) {
                        if (state.models[name] !== 'correct' || model[state.models[name]].name === null)
                          model[state.models[name]] = { name: name, priority: card.priority };
                      }
                    });
                  }
                });
              }
              break;
          }
        }
      });
      return { correct: model.correct.name, protect: model.protect.name, optimize: model.optimize.name };
    },
    transportsList: state => {
      return state.transportsList;
    },
    isStepTransportValid: state => {
      let count = 0;
      for (let transport of state.transportsList) {
        if (transport.isActive) count++;
      }
      return count <= 2 && count > 0;
    },
    getSlideValue: (state, getters) => data => {
      return getters.getSteps[data].value;
    },
    getMonoCheck: (state, getters) => data => {
      return getters.getSteps[data].checked;
    },
    getChecked: (state, getters) => data => {
      return getters.getSteps[data.step].cards[data.index].checked;
    },
    getSteps: state => {
      return state.steps.filter(step => !step.isDeactivated);
    },
    isFilled: state => {
      return state.isFilled;
    },
    getOtherChecked: state => data => {
      return state.steps[data].type === 'correct' ? state.steps[data].checked === -1 : state.steps[data].checked;
    },
    isValid: (state, getters) => data => {
      switch (getters.getSteps[data].inputType) {
        case 'OCQNoImages':
          return getters.getSteps[data].checked === 0 || getters.getSteps[data].checked;
        case 'slider':
          return getters.getSteps[data].value || getters.getSteps[data].value === 0;
        case 'OCQSmall':
          // eslint-disable-next-line no-case-declarations
          let count = getters.getSteps[data].cards.reduce((accu, cur) => (cur.checked ? accu + 1 : accu), 0);
          return (count && count <= 3) || getters.getSteps[data].checked;
        default:
          return (
            getters.getSteps[data].checked === 0 ||
            getters.getSteps[data].checked ||
            (getters.getSteps[data].cards &&
              getters.getSteps[data].cards.some(card => {
                return card.checked;
              }))
          );
      }
    },
  },
};
